import React from "react";
import { useNavigate } from "react-router-dom";
import s from "../styles/AddTeamMemberButton.module.css";

type Props = {
    to?: string;              // route to navigate to (optional when onClick is provided)
    label?: string;           // text on the button
    className?: string;       // optional extra classes
    disabled?: boolean;
    onClick?: () => void;     // optional click handler (takes precedence over navigation)
};

export default function AddTeamMemberButton({
                                                to = "/add-member",
                                                label = "Add team member",
                                                className = "",
                                                disabled = false,
                                                onClick,
                                            }: Props) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (disabled) return;

        if (onClick) {
            onClick();
        } else {
            navigate(to);
        }
    };

    return (
        <button
            type="button"
            className={`${s.btn} ${disabled ? s.disabled : ""} ${className}`}
            onClick={handleClick}
            aria-label={label}
        >
      <span className={s.icon} aria-hidden="true">
        {/* plus-in-circle icon */}
          <svg viewBox="0 0 24 24" width="18" height="18">
          <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 8v8M8 12h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </span>
            <span className={s.text}>{label}</span>
        </button>
    );
}